module.exports = __webpack_public_path__ + "img/American-Express.951e2457.png";